import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import { Helmet } from 'react-helmet'
import { Layout } from '../components/common'
import { MetaData } from '../components/common/meta'

const getTitle = t => {
    var title=""
    if(t.search("#") > -1){
        title=t.split("#")[1]
    } else {
        title=t
    }
    
    return title
}


const Page = ({ data, location }) => {

    const page = data.ghostPage
    var pages = data.allGhostPage.edges
    const hpFlag = data.ghostPage.tags.some(item => item.slug === 'hash-hpage')
    const solutionsFlag = data.ghostPage.tags.some(item => item.slug === 'hash-solutions')
    const cFlag = data.ghostPage.tags.some(item => item.slug === 'hash-company')

    const tempFlag = (page.slug === "legal" ? true : (page.slug === "blog" ? true : (page.slug === "modern-slavery-policy" ? true : false)))

    const bodyCls = (tempFlag ? (page.slug === "legal" ? "post company" : (page.slug === "blog" ? "post blog" : (page.slug === "modern-slavery-policy" ? "post company" : false))) : "home")

    return (
        <>
            <MetaData
                data={data}
                location={location}
                type="website"
            />
            <Helmet>
                <style type="text/css">{`${page.codeinjection_styles}`}</style>
            </Helmet>
            <Layout bodyClass={(solutionsFlag ? "post wtf" : (cFlag ? "post company" : bodyCls)) }>
                {hpFlag ? 
                <div className="container">

                    <header className="author-header">
                        <div className="author-header-content">
                            <div className="author-header-meta">
                            <a key={`ahilink-x`} className="author-header-item" href="/" >Overview</a>
                                {pages.filter(({ node }) => {
                                        if (node.tags.some(x => x.slug === "hash-hpage")) {
                                            return node
                                        }
                                    }).sort((a, b) => {
                                    let fa = parseInt(a.node.title.split("#")[0]),
                                        fb = parseInt(b.node.title.split("#")[0]);

                                    if (fa < fb) {
                                        return -1;
                                    }
                                    if (fa > fb) {
                                        return 1;
                                    }
                                    return 0;
                                }).map(({ node }, k) => (
                                    (page.slug== node.slug ? <a key={`ahilink-${k}`} className="author-header-item-sel" href={`/${node.slug}`} >{getTitle(node.title)}</a> : <a key={`ahilink-${k}`} className="author-header-item" href={`/${node.slug}`} >{getTitle(node.title)}</a>)
                                ))}
                            </div>
                        </div>
                    </header>

                </div>
                :""}
                {solutionsFlag ? 
                <div className="container">

                    <header className="author-header">
                        <div className="author-header-content">
                            <div className="author-header-meta">
                                <a key={`ahilink-x`} className="author-header-item" href="/solutions/" >Overview</a>
                                    {pages.filter(({ node }) => {
                                        if (node.tags.some(x => x.slug === "hash-solutions")) {
                                            return node
                                        }
                                    }).sort((a, b) => {
                                        let fa = parseInt(a.node.title.split("#")[0]),
                                            fb = parseInt(b.node.title.split("#")[0]);

                                        if (fa < fb) {
                                            return -1;
                                        }
                                        if (fa > fb) {
                                            return 1;
                                        }
                                        return 0;
                                    }).map(({ node }, k) => (
                                        (page.slug == node.slug ? <a key={`ahilink-${k}`} className="author-header-item-sel" href={`/${node.slug}`} >{getTitle(node.title)}</a> : <a key={`ahilink-${k}`} className="author-header-item" href={`/${node.slug}`} >{getTitle(node.title)}</a>)
                                    ))}
                            </div>
                        </div>
                    </header>

                </div>
                :""}
                {cFlag ? 
                <div className="container">

                    <header className="author-header">
                        <div className="author-header-content">
                            <div className="author-header-meta">
                                    {pages.filter(({ node }) => {
                                        if (node.tags.some(x => x.slug === "hash-company")) {
                                            return node
                                        }
                                    }).sort((a, b) => {
                                        let fa = parseInt(a.node.title.split("#")[0]),
                                            fb = parseInt(b.node.title.split("#")[0]);

                                        if (fa < fb) {
                                            return -1;
                                        }
                                        if (fa > fb) {
                                            return 1;
                                        }
                                        return 0;
                                    }).map(({ node }, k) => (
                                        //<a key={`ahilink-${k}`} className="author-header-item-sel" href={`/${node.slug}`} >{getTitle(node.title)}</a>
                                        (page.slug == node.slug ? (node.slug=="press-kit" ? "" : <a key={`ahilink-${k}`} className="author-header-item-sel" href={`/company/#${node.slug}`} >{getTitle(node.title)}</a>) : <a key={`ahilink-${k}`} className="author-header-item" href={`/company/#${node.slug}`} >{getTitle(node.title)}</a>)
                                    ))}
                            </div>
                        </div>
                    </header>

                </div>
                :""}
                <div className="container" style={{marginTop: (tempFlag ? "69px" : "0")}}>
                    <article className="content">
                        {hpFlag ? "" : <h1 className="content-title">{getTitle(page.title)}</h1>}

                        <section
                            className="content-body load-external-scripts"
                            dangerouslySetInnerHTML={{ __html: page.html }}
                        />
                    </article>
                </div>
            </Layout>
        </>
    )
}

Page.propTypes = {
    data: PropTypes.shape({
        ghostPage: PropTypes.shape({
            codeinjection_styles: PropTypes.object,
            title: PropTypes.string.isRequired,
            feature_image: PropTypes.string,
        }).isRequired,
    }).isRequired,
    location: PropTypes.object.isRequired,
}

export default Page

export const postQuery = graphql`
    query($slug: String!) {
        ghostPage(slug: { eq: $slug }) {
            ...GhostPageFields
        }
        allGhostPage(filter: {tags: {elemMatch: {slug: {in: ["hash-hpage", "hash-solutions", "hash-company"]}}}}) {
            edges {
              node {
                ...GhostPageFields
              }
            }
        }
    }
`
